export class DiveIN {
    constructor() {}
    commonStep = 'stepper.form.commun.divers.step';
    step = 'stepper.form.dive_in.step';
    step1 = 'stepper.form.dive_in.step1';
    step2 = 'stepper.form.dive_in.step2';
    step3 = 'stepper.form.dive_in.step3';
    step4 = 'stepper.form.dive_in.step4';
    step5 = 'stepper.form.dive_in.step5';
    step6 = 'stepper.form.dive_in.step5';
    step7 = 'stepper.form.dive_in.step7';
    step8 = 'stepper.form.dive_in.step8';
    step9 = 'stepper.form.dive_in.step9';
    step10 = 'stepper.form.dive_in.step10';
    step11 = 'stepper.form.dive_in.step11';
  }
